import { DocumentNode, gql } from '@apollo/client';

import { GetAppropriateEventLink_EventFragment } from './graphql-types/GetAppropriateEventLink_EventFragment';

export const getAppropriateEventLink: {
  (event?: GetAppropriateEventLink_EventFragment): string;
  eventFragment: DocumentNode;
} = (event) => {
  if (!event) {
    return '/';
  }
  switch (event.__typename) {
    case 'ConferenceEventV2':
      return `/events/conferences/${event._id}`;
    default:
      return `/events/${event._id}`;
  }
};

getAppropriateEventLink.eventFragment = gql`
  fragment GetAppropriateEventLink_EventFragment on EventV2 {
    _id
    ... on SimpleEventV2 {
      _id
    }
    ... on ConferenceEventV2 {
      _id
    }
  }
`;
